import React from "react";
import {
  Create,
  TextInput,
  SimpleForm,
  SelectInput,
  ReferenceInput,
  AutocompleteInput,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  useRedirect,
  useRefresh,
  CreateProps,
} from "react-admin";

import TitleBreadcrumb from "components/TitleBreadcrumb";
import SanitizedGrid from "components/SanitizedGrid";
import { Grid, Typography } from "@material-ui/core";
import DaysOfWeekInput from "components/DaysOfWeekInput";
import { arrivalTimeLabel, schoolTimeLabel, typeList } from "./util";
import { GetParam } from "utils/tools";
import CustomCreateToolbar from "components/CustomCreateToolbar";
import CustomTimePickerInput from "components/CustomTimePickerInput";

const BusSchedulesCreate = (props: CreateProps) => {
  const redirect = useRedirect();
  const refresh = useRefresh();
  const param = GetParam();

  const breadcrumb = [
    { title: "Schools", link: `/schools` },
    {
      title: "Bus Schedules",
      link: `/schools/${param.get("schoolId")}/show/2`,
    },
    { title: "Create", link: "" },
  ];

  const CustomRedirect = (props: { data: IBusSchedule }) => {
    redirect(`/schools/${props.data.schoolId}/show/2`);
    refresh();
  };

  const transform = async (data: any) => ({
    ...data,
    isMonday: data.isMonday ? true : false,
    isTuesday: data.isTuesday ? true : false,
    isWednesday: data.isWednesday ? true : false,
    isThursday: data.isThursday ? true : false,
    isFriday: data.isFriday ? true : false,
  });

  return (
    <>
      <TitleBreadcrumb paths={breadcrumb} />
      <Typography variant="h4">New Bus Schedule</Typography>
      <Create transform={transform} onSuccess={CustomRedirect} {...props}>
        <SimpleForm toolbar={<CustomCreateToolbar />}>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">School and Type Schedule</Typography>
            </Grid>
            <Grid item xs={4}>
              <ReferenceInput
                label="Select School"
                source="schoolId"
                reference="schools"
                disabled
              >
                <AutocompleteInput optionText="name" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={4}>
              <SelectInput source="type" choices={typeList} disabled />
            </Grid>
            <Grid item xs={4}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Details</Typography>
            </Grid>

            <Grid item xs={3}>
              <TextInput source="name" label="Wave Name" />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={8}>
              <ReferenceArrayInput
                source="levelIds"
                label="Select Levels"
                reference="levels"
                filter={{ SchoolId: Number(param.get("schoolId")) }}
              >
                <AutocompleteArrayInput optionText="name" />
              </ReferenceArrayInput>
            </Grid>
            <Grid item xs={4}></Grid>

            <Grid item xs={4}>
              <CustomTimePickerInput
                source="schoolTime"
                label={`${schoolTimeLabel(param.get("type"))}`}
              />
            </Grid>
            <Grid item xs={4}>
              <CustomTimePickerInput
                source="arrivalTime"
                label={`${arrivalTimeLabel(param.get("type"))}`}
              />
            </Grid>
            <Grid item xs={4}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Days of Week</Typography>
            </Grid>

            <DaysOfWeekInput />
          </SanitizedGrid>
        </SimpleForm>
      </Create>
    </>
  );
};

export default BusSchedulesCreate;
